import moment from "moment";
import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { ViewLink } from "../_components/AdminRowActions";

const USER_STATUS = {
  PENDING_VERIFICATION: { tone: "warning", text: "Pending Verification" },
  PENDING_APPROVAL: { tone: "warning", text: "Pending Approval" },
  ACTIVE: { tone: "success", text: "Approved" },
  REJECTED: { tone: "danger", text: "Rejected" },
  DEACTIVE: { tone: "danger", text: "Deactive" },
};

const getStatus = (status) => USER_STATUS[status] || { tone: "neutral", text: "-" };

const BusinessUserItem = ({
  user: {
    _id,
    email,
    date,
    businessDetail,
    status,
    iataEligible,
    iataDiscount,
    deferredPaymentEligible,
  },
  count,
}) => {
  const statusMeta = getStatus(status);

  // Payment type and IATA rate are chosen by the admin when approving the
  // account, so until it is ACTIVE they are only defaults — leave them blank
  // rather than showing a misleading "Advance".
  const isApprovedAccount = status === "ACTIVE";

  return (
    <tr>
      <td className={cellClass}>{count + 1}</td>
      <td className={cellClass}>{businessDetail?.businessInformation?.businessName}</td>
      <td className={cellClass}>{email}</td>
      <td className={cellClass}>
        {isApprovedAccount && (
          <AdminBadge tone={deferredPaymentEligible ? "purple" : "info"}>
            {deferredPaymentEligible ? "Deferred" : "Advance"}
          </AdminBadge>
        )}
      </td>
      <td className={cellClass}>
        <AdminBadge tone={statusMeta.tone}>{statusMeta.text}</AdminBadge>
      </td>
      <td className={cellClass}>
        {isApprovedAccount && (iataEligible ? `${iataDiscount}%` : "-")}
      </td>
      <td className={cellClass}>-</td>
      <td className={`${cellClass} tw:whitespace-nowrap`}>{moment(date).locale("en").format("YYYY/MM/DD")}</td>
      <td className={stickyCellClass}>
        <AdminRowActions>
          <ViewLink to={`/admin/userlist-business/${_id}`} label="View user" />
        </AdminRowActions>
      </td>
    </tr>
  );
};

export default BusinessUserItem;
